export var AnchorPositionContent;
(function (AnchorPositionContent) {
    AnchorPositionContent["Starboard"] = "starboard";
    AnchorPositionContent["Port"] = "port";
    AnchorPositionContent["Aft"] = "aft";
})(AnchorPositionContent || (AnchorPositionContent = {}));
//# sourceMappingURL=AnchorPositionContent.js.map